module.exports = __webpack_public_path__ + "img/18_004.2d2c4538.webp";